@if (breakpointChanges$ | async; as isSmallScreen) {
  @if (!isSmallScreen.matches) {
    <td-wb-help-desktop [articleId]="articleId()"
      (articleIdChange)="changeArticleId($event)"
      (close)="close()"
      class="td-wb-help--hide" />
  }
  @if (isSmallScreen.matches) {
    <td-wb-help-mobile [articleId]="articleId()"
      (articleIdChange)="changeArticleId($event)"
      (close)="close()"
      class="td-wb-help--hide" />
  }
}
